module.exports = __webpack_public_path__ + "static/media/cyclelane.f71f2b40.png";